export default __webpack_public_path__ + "static/media/avatar_98.afa44c01.png";